import React, { useState } from "react"

import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
} from "react-accessible-accordion"

import {
  StyledAccordion,
  StyledAccordionItemButton,
  Arrow,
} from "./index.style"

import "react-accessible-accordion/dist/fancy-example.css"

const Accordion = ({
  data,
  activeArrowStyle,
  inActiveArrowStyle,
  ...props
}) => {
  const [openTabs, setOpenTabs] = useState([])

  return (
    <StyledAccordion allowZeroExpanded {...props} onChange={setOpenTabs}>
      {data.map((item, index) => (
        <AccordionItem key={index} uuid={index}>
          <AccordionItemHeading>
            <StyledAccordionItemButton>
              {item.renderHeader({ active: openTabs.includes(index) })}
              <Arrow
                open={openTabs.includes(index)}
                style={
                  openTabs.includes(index)
                    ? activeArrowStyle || {}
                    : inActiveArrowStyle || {}
                }
              >
                {openTabs.includes(index) ? "-" : "+"}
              </Arrow>
            </StyledAccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel>{item.renderContent()}</AccordionItemPanel>
        </AccordionItem>
      ))}
    </StyledAccordion>
  )
}

export default Accordion
